export { apolloClientAiApps, devTarget } from "./apolloClientAiApps.js";
